
export const English = {
    pagePrivate: "Private Vehicle Motor Insurance Application",
    pageCommercial: "Commercial Vehicle Motor Insurance Application",
    pageSpecial: "Special Type Motor Insurance Application",
    pageMotorcycle: "Motorcycle Insurance Application",
    pagePSV: "Public Service Vehicle (PSV) Insurance Application",
    continued: " (Continued)",

    benefitsHeading: "Additional Benefits",
    benefitsSubheading: "Please select any additional benefits you would like us to add to your cover",

    protectorBenText: "<b>Excess Protector</b><br>This is an additional payment that you make together with your premium to keep you from paying the excess fee in case of damage, fire or theft",
    theftBenText: "<b>Excess Protector Theft</b><br>This protects you from paying excess in the event your car is stolen",
    politicalBenText: "<b>Political violence and terrorism</b><br>This covers damages incurred from political violence and terrorism",
    lossUseBenText: "<b>Loss of use</b><br>Receive an alternative car while your car is being repaired",
    windBenText: "<b>Windscreen above TZS 1,000,000</b><br>If you want to insure your windscreen above the TZS. 1,000,000 free limit",
    entBenText: "<b>Entertainment above TZS 500,000</b><br>If you want to insure your entertainment above the TZS. 500,000 free limit",

    windscreenAmountLabel: "Enter windscreen insurance amount",
    entertainmentAmountLabel: "Enter entertainment insurance amount",

    coverStartDateLabel: "Cover Start Date",
    coverStartDateDesc: "When you would like the cover to start",
    coverStartDateValidation: "You have to select a start date for your cover",

    cancel: "Cancel",
    saveContinue: "Save and Continue",

    requiredValidation: "This field is required",
    minimumValidation: "Minimum amount must be above ",
    maximumValidation: "Maximum valid amount is ",
    invalidNumValidation: "Invalid number",
    regValidation: "Invalid Vehicle Registration number",
    emailValidation: "Invalid email address",

    submissionFailed: "Submission Failed",
    savingError: "An error occurred while saving the form details",
    cancelFailed: "An error occurred",
    cancelError: "Something unexpected happened.",
    cancelNope: "Hitilafu imetokea",
    unexpectedError: "An unexpected error occurred",
    tryAgain: "TRY AGAIN",
    confirmSubmission: "Confirm submission",
    proceedDesc: "Please proceed only if you have verified that the form details are correct",
    back: "Back",
    proceed: "Proceed",
    warning: "Warning",
    confirmCancel: "Are you sure you want to cancel the application?",
    backSmallCaps: "back",
    cancelApplication: "Cancel application",
    // DETAILS
    detailsSubHeading: "Enter Personal Details",
    organizationNameLabel: "Enter the organization name",
    fullNameLabel: "Enter Full Name",
    emailLabel: "Enter Email Address",
    phoneLabel: "Enter Phone Number",
    dobLabel: "Date of Birth",
    genderLabel: "Select Gender",
    regionLabel: "Enter Region",
    districtLabel: "Enter District",
    adressLabel: "Postal Address",
    idTypeLabel: "Select Identification Type",
    IdTypePlaceHolders: ["TAXPAYER IDENTIFICATION NUMBER (TIN)"],
    tinText: "TAXPAYER IDENTIFICATION NUMBER (TIN)",
    // IdTypePlaceHolders: ["NATIONAL IDENTIFICATION NUMBER (NIN)", "TAXPAYER IDENTIFICATION NUMBER (TIN)", "VOTERS REGISTRATION NUMBER","PASSPORT NUMBER", "DRIVING LICENSE"],

    // 3P
    insuranceQuestion: "What type of entity is the vehicle registered to?",
    individualText: "Individual",
    corporateText: "Corporate",

    // CLAIM
    claimTitle: "Report Claim Application",
    claimSubheading: "Enter Details",
    regLabel: "Vehicle Registration",
    regHint: "For example: T123ABC",
    dateLabel: "Date of loss/accident",
    locationLabel: "Location of loss/accident",
    emailClaimLabel: "Email address of insured",
    phoneClaimLabel: "Phone number of insured",

    M: "Male",
    F: "Female",
    O: "Other"
};

export const Kiswahili = {
    pagePrivate: "Fomu ya chombo binafsi",
    pageCommercial: "Fomu ya chombo cha biashara",
    pageSpecial: "Fomu ya chombo cha magari ya matumizi maalum",
    pageMotorcycle: "Fomu ya pikipiki",
    pagePSV: "Fomu ya Gari la Utumishi wa Umma (PSV)",
    continued: " (Inaendelea)",

    benefitsHeading: "Huduma za ziada",
    benefitsSubheading: "Tafadhali chagua huduma za ziada ambazo ungependa kuongeza kwenye bima yako",

    protectorBenText: "<b>Ulinzi wa chombo</b><br>Haya ni malipo ya ziada unayofanya pamoja na malipo yako ili kukuzuia kulipa ada ya ziada endapo utatokea uharibifu, moto au wizi.",
    theftBenText: "<b>Ulinzi dhidi ya wizi wa chombo</b><br>Hii ni faida itakayokufanya usilipe kiasi cha ziada (excess) iwapo utapatwa na janga la wizi wa chombo.",
    politicalBenText: "<b>Ulinzi dhidi ya vurugu za kisiasa na ugaidi</b><br>Hii ni faida itakayokufanya usilipe kiasi cha ziada iwapo utapatwa na janga la uharibifu au hasara itokanayo na vurugu za kisiasa au ugaidi.",
    lossUseBenText: "<b>Ulinzi dhidi ya kupoteza matumizi ya chombo chako</b><br>Hii ni faida itakayokufanya upewe usafiri mbadala wakati gari lako ikiwa katika matengenezo.",
    windBenText: "<b>Kioo chenye thamani ya zaidi ya TZS 1,000,000</b><br>Katia bima kioo cha gari lako chenye thamani ya zaidi ya TZS 1,000,000",
    entBenText: "<b>Muziki wa gari wenye thamani zaidi ya TZS 500,000</b><br>Katia bima muziki wa gari lako wenye thamani zaidi ya TZS 500,000",

    windscreenAmountLabel: "Weka kiasi cha bima ya kioo cha mbele",
    entertainmentAmountLabel: "Weka kiasi cha bima ya muziki wa gari",

    coverStartDateLabel: "Tarehe ya Kuanza kwa Bima",
    coverStartDateDesc: "Tarehe unayotaka bima ianze",
    coverStartDateValidation: "Lazima uchague tarehe ya kuanza kwa bima yako",

    cancel: "Ghairi",
    saveContinue: "Hifadhi na Endelea",

    requiredValidation: "Sehemu hii inahitajika",
    minimumValidation: "Kiasi cha chini lazima kiwe zaidi ya ",
    maximumValidation: "Kiwango cha juu halali ni ",
    invalidNumValidation: "Nambari batili",
    regValidation: "Nambari ya Usajili wa Gari ni batili",
    emailValidation: "Anwani ya barua pepe si sahihi",

    submissionFailed: "Uwasilishaji Umeshindwa",
    savingError: "Hitilafu imetokea wakati wa kuhifadhi maelezo ya fomu",
    cancelFailed: "Hitilafu imetokea",
    cancelError: "Kitu kisichotarajiwa kilitokea.",
    cancelNope: "Failed to cancel. An error occurred",
    unexpectedError: "Hitilafu isiyotarajiwa imetokea",
    tryAgain: "JARIBU TENA",
    confirmSubmission: "Thibitisha uwasilishaji",
    proceedDesc: "Tafadhali endelea tu ikiwa umethibitisha kuwa maelezo ya fomu ni sahihi",
    back: "Nyuma",
    proceed: "Endelea",
    warning: "Onyo",
    confirmCancel: "Je, una uhakika unataka kughairi programu hii?",
    backSmallCaps: "nyuma",
    cancelApplication: "Ghairi programu",
    // DETAILS
    detailsSubHeading: "Tafadhali Jaza Taarifa Zako",
    fullNameLabel: "Andika jina kamili",
    organizationNameLabel: "Andika jina la shirika",
    emailLabel: "Andika barua pepe",
    phoneLabel: "Andika namba ya simu",
    dobLabel: "Tarehe ya Kuzaliwa",
    genderLabel: "Jaza Jinsia",
    regionLabel: "Jaza Mkoa",
    districtLabel: "Jaza Wilaya",
    adressLabel: "Anwani ya Posta",
    idTypeLabel: "Chagua aina ya kitambulisho",
    IdTypePlaceHolders: ["NAMBA YA KITAMBULISHO CHA MLIPA KODI (TIN)"],
    tinText: "NAMBA YA KITAMBULISHO CHA MLIPA KODI (TIN)",
    // IdTypePlaceHolders: ["NAMBA YA KITAMBULISHO CHA TAIFA (NIN)", "NAMBA YA KITAMBULISHO CHA MLIPA KODI (TIN)", "NAMBA YA KUJIANDIKISHA KUPIGA KURA", "NAMBA YA PASIPOTI", "LESENI YA KUENDESHA GARI"],

    // 3P
    insuranceQuestion: "Chombo kimesajiliwa kwa shirika la aina gani?",
    individualText: "Mtu binafsi",
    corporateText: "Shirika",

    // CLAIM
    claimTitle: "Fomu ya kuripoti madai",
    claimSubheading: "Tafadhali Jaza Taarifa Zako",
    regLabel: "Namba za usajili wa chombo chako",
    regHint: "Kwa mfano: T123ABC",
    dateLabel: "Tarehe ya ajali/wizi",
    locationLabel: "Mahali lilipotokea tukio",
    emailClaimLabel: "Barua pepe",
    phoneClaimLabel: "Namba ya simu",

    M: "Mwanaume",
    F: "Mwanamke",
    O: "Nyingine"
};
